import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tag,
} from "antd";
import { useState, useCallback, useMemo, useEffect } from "react";
import {
  ReloadOutlined,
  FileExcelOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { HEADERS_EXPORT_BEN, POST_MAIN_CUT_PAY_FN } from "../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import MotionHoc from "../../../utils/MotionHoc";
import CloseContno from "./modal/CloseContno";
import BillAfterCourtOldData from "../afterCourt/modal/BillAfterCourtOldData";

const { Option } = Select;

const STATUS_GROUP = { 1: "A", 2: "B", 3: "A", 4: "B" };
const CLOSE_CONTNO = { A: 1, B: 0 };
const FILTER_RULES = {
  1: (item) => !item.checkJudgeFn && item.closeContno,
  2: (item) => item.checkJudgeFn && !item.closeContno,
  3: (item) => item.checkJudgeFn && item.closeContno,
  4: (item) => !item.checkJudgeFn && !item.closeContno,
};

const STATUS_OPTIONS = [
  { value: 1, icon: "🟡", label: "รอตัดจ่าย" },
  { value: 2, icon: "🟢", label: "ตัดจ่ายแล้ว (ปิดบัญชีแล้ว)" },
  { value: 3, icon: "🔵", label: "ตัดจ่ายแล้ว (ยังไม่ปิดบัญชี)" },
  { value: 4, icon: "⚪", label: "ปิดบัญชี (ยังไม่ตัดจ่าย)" },
];

const Main = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const [dataArr, setDataArr] = useState([]);
  const [rawArr, setrawArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(1);
  const [dataRecord, setDataRecord] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [isModalBillAfterCourtOldData, setIsModalBillAfterCourtOldData] =
    useState(false);

  const filterData = useCallback((rawData, status) => {
    const rule = FILTER_RULES[status];
    if (!rule) return;
    const filtered = rawData.filter(rule);
    setDataArr(filtered);
  }, []);

  const loadMain = useCallback(
    async (status) => {
      setLoading(true);

      console.log("status", status);

      try {
        const group = STATUS_GROUP[status];
        const res = await axios.post(
          POST_MAIN_CUT_PAY_FN,
          { userId, closeContno: CLOSE_CONTNO[group] },
          { headers: HEADERS_EXPORT_BEN },
        );
        console.log("res", res);

        if (res.data?.length > 0) {
          setrawArr(res.data);
          filterData(res.data, status);
        } else {
          setDataArr([]);
          setrawArr([]);
          message.info("ไม่มีข้อมูล");
        }
      } catch (error) {
        if (error.name !== "CanceledError") {
          message.error(
            error.response?.data?.message ||
              error.message ||
              "ไม่สามารถโหลดข้อมูลได้",
          );
          setDataArr([]);
        }
      } finally {
        setLoading(false);
      }
    },
    [userId, filterData],
  );

  useEffect(() => {
    loadMain(processStatus);
  }, []);

  const handleChangeStatus = useCallback(
    (value) => {
      const isSameGroup = STATUS_GROUP[value] === STATUS_GROUP[processStatus];
      console.log("isSameGroup", isSameGroup);

      if (!isSameGroup) {
        setDataArr([]);
        loadMain(value);
      } else {
        filterData(rawArr, value);
      }
      setProcessStatus(value);
    },
    [processStatus, dataArr, filterData],
  );

  const handleReloadJudgment = useCallback(() => {
    setDataRecord(null);
    loadMain(processStatus);
  }, [loadMain, processStatus]);

  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    message.info("ล้างตัวกรองสำเร็จ");
  }, []);

  const arrayTable = useMemo(() => {
    if (!dataArr.length) return [];
    const q = searchInputTable.trim().toLowerCase();
    if (!q) return dataArr;
    return dataArr.filter((item) =>
      [
        item.newContno,
        item.CUSCOD,
        item.CONTNO,
        item.NAME1,
        item.NAME2,
        `${item.SNAM || ""}${item.NAME1 || ""} ${item.NAME2 || ""}`,
      ].some((v) =>
        String(v ?? "")
          .toLowerCase()
          .includes(q),
      ),
    );
  }, [dataArr, searchInputTable]);

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      width: 150,
    },
    {
      title: "เลขสัญญาใหม่",
      dataIndex: "newContno",
      key: "newContno",
      align: "center",
      width: 150,
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "fullName",
      align: "center",
      render: (_, r) =>
        `${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim(),
    },
    {
      title: "ผลพิจารณา",
      dataIndex: "redCaseNumber",
      key: "redCaseNumber",
      align: "center",
      render: (text, record) => {
        return (
          <div>
            <Tag
              color={record.flagLoanNew === 1 ? "green" : "red"}
              style={{ textAlign: "center" }}
            >
              {record.flagLoanNew === 1 ? "ทำยอม" : "พิพากษา"}
              {record.LAW_TYPE_ID === 6 ? "(ฟ้องส่วนต่าง)" : null}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "วันที่ดำเนินการ",
      align: "center",
      render: (_, r) => (
        <Tag color={r.dateCheckJudgeFn ? "green" : "default"}>
          {r.dateCheckJudgeFn
            ? dayjs(r.dateCheckJudgeFn).add(543, "year").format("D MMM YY")
            : "-"}
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      key: "actions",
      align: "center",
      width: 180,
      render: (_, record) => (
        <Space>
          <Button
            color="green"
            variant="outlined"
            icon={<FileSearchOutlined />}
            onClick={() => {
              setDataRecord(record);
              setIsModalBillAfterCourtOldData(true);
            }}
          >
            รายละเอียด
          </Button>
          <Button
            color={
              processStatus === 1 || processStatus === 4 ? "blue" : "green"
            }
            variant="outlined"
            icon={<FileExcelOutlined />}
            onClick={() => {
              setDataRecord(record);
              setIsModal(true);
            }}
          >
            {processStatus === 1 || processStatus === 4
              ? "ปิดบัญชี"
              : "ดูตัดจ่าย"}
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 8,
              background: "#fff3cc",
              border: "1px solid #ffcb05",
            }}
          >
            <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
            <span
              style={{
                fontSize: 13,
                fontWeight: 500,
                color: "#efa420",
                whiteSpace: "nowrap",
              }}
            >
              เลือกสถานะ
            </span>
          </div>

          <Select
            size="large"
            style={{ minWidth: 240 }}
            placeholder="เลือกสถานะ"
            value={processStatus}
            onChange={(v) => {
              handleChangeStatus(v);
              setSearchInputTable("");
            }}
            optionLabelProp="label"
          >
            {STATUS_OPTIONS.map(({ value, icon, label }) => (
              <Option key={value} value={value} label={`${icon} ${label}`}>
                <Space>
                  <span style={{ fontSize: 14 }}>{icon}</span>
                  <span>{label}</span>
                </Space>
              </Option>
            ))}
          </Select>

          {/* ✅ Tag ชิดขวา */}
          {processStatus &&
            (() => {
              const found = STATUS_OPTIONS.find(
                (o) => o.value === processStatus,
              );
              return found ? (
                <Tag
                  style={{
                    marginLeft: "auto",
                    fontSize: 13,
                    borderRadius: 20,
                    padding: "3px 12px",
                    background: "#fff3cc",
                    border: "1px solid #ffcb05",
                    color: "#efa420",
                    fontWeight: 500,
                  }}
                >
                  {found.icon} {found.label}
                </Tag>
              ) : null;
            })()}
        </div>
      </Card>

      <Card>
        <Spin spinning={loading} tip="กำลังโหลดข้อมูล...">
          <Row gutter={[0, 16]}>
            <Col span={24} style={{ textAlign: "end" }}>
              <Space size={10} wrap>
                <Input
                  placeholder="ค้นหาเลขสัญญา, ชื่อ"
                  value={searchInputTable}
                  onChange={(e) => setSearchInputTable(e.target.value)}
                  style={{ width: 250, borderRadius: 8 }}
                  size="small"
                  allowClear
                  suffix={<span>🔍</span>}
                />
                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleResetFilter}
                  size="large"
                  style={{
                    borderRadius: 8,
                    backgroundColor: "#fff1f0",
                    borderColor: "#ffa39e",
                    color: "#cf1322",
                  }}
                >
                  ล้างตัวกรอง
                </Button>
              </Space>
            </Col>

            <Col span={24}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                rowKey={(r) => r.CONTNO || r.id}
                scroll={{ x: 1000 }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `ทั้งหมด ${total} รายการ`,
                  pageSizeOptions: ["10", "20", "50", "100"],
                }}
                footer={() => (
                  <p style={{ margin: 0 }}>
                    จำนวนสัญญาทั้งหมด {arrayTable.length}
                  </p>
                )}
              />
            </Col>
          </Row>
        </Spin>

        {isModal && (
          <CloseContno
            open={isModal}
            close={() => setIsModal(false)}
            dataDefault={dataRecord}
            funcUpdateStatus={handleReloadJudgment}
          />
        )}
        {isModalBillAfterCourtOldData && (
          <BillAfterCourtOldData
            open={isModalBillAfterCourtOldData}
            close={() => setIsModalBillAfterCourtOldData(false)}
            dataDefault={dataRecord}
          />
        )}
      </Card>
    </>
  );
};

const MainCutPay1And8 = MotionHoc(Main);
export default MainCutPay1And8;
